export interface IPowerbarSwitchEventContext {
  newValue: boolean;
}

export interface IPowerbarSearchItemActivatedEventContext {
  label: string;
  target: string;
  href: string;
  modal?: boolean;
}

function getFS() {
  const _FS = (<any>window).FS;
  if (_FS?.event && typeof _FS.event === "function") {
    return _FS;
  } else return undefined;
}

export function powerbarSwitchEvent(context: IPowerbarSwitchEventContext) {
  getFS()?.event('powerbar-switch', context);
}

export function powerbarSearchItemActivatedEvent(context: IPowerbarSearchItemActivatedEventContext) {
  getFS()?.event('powerbar-search-item-activated', context);
}





